"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
TYCOON.pageScript = TYCOON.pageScript || {
  init: {}
};
TYCOON.pageScript = function () {
  // コンストラクタ  =================================================================
  function init() {
    TYCOON.common.initAccordion();
    initItemSlider();
    initPhotoSwipe();
  }

  /*
  * 商品スライダー
  *
  */
  var ProductItemSlider = /*#__PURE__*/function () {
    function ProductItemSlider() {
      _classCallCheck(this, ProductItemSlider);
      this.$thumbnailSlider = $('.js-thumbnailSlider');
      this.$childSlider = $('.js-childSlider');
      this.$pagination = $('.js-pagination');
      this.$pageNumber = $('.js-itemSliderNumber');
      if (!this.$thumbnailSlider.length || !this.$childSlider.length) return;
      this.init();
    }

    // 初期化
    return _createClass(ProductItemSlider, [{
      key: "init",
      value: function init() {
        var _this = this;
        this.changeSlider();
        TYCOON.data.$window.on('load onBreakpointChange', function () {
          return _this.changeSlider();
        });
      }

      // ブレークポイント変更時
    }, {
      key: "changeSlider",
      value: function changeSlider() {
        if (TYCOON.data.$MQ === 'LANDSCAPE') {
          this.destroySlick();
        } else {
          this.startSlick();
        }
      }

      // スライダーを初期化
    }, {
      key: "startSlick",
      value: function startSlick() {
        var _this2 = this;
        if (this.$thumbnailSlider.hasClass('slick-initialized')) return;

        // メインスライダー
        this.$thumbnailSlider.on('init.itemSlider', function (event, slick) {
          if (_this2.$pageNumber.children().length === 0) {
            _this2.$pageNumber.append('<span class="js-pageCurrent"></span>' + '<span class="c-paginationSeparator"> / </span>' + '<span class="js-pageTotal"></span>');
          }
          var $current = _this2.$pageNumber.find('.js-pageCurrent');
          var $total = _this2.$pageNumber.find('.js-pageTotal');
          $current.text((slick.currentSlide || 0) + 1);
          $total.text(slick.slideCount);
        }).on('beforeChange.itemSlider', function (e, slick, currentSlide, nextSlide) {
          _this2.$pageNumber.find('.js-pageCurrent').text(nextSlide + 1);
        }).slick({
          arrows: true,
          infinite: false,
          appendArrows: this.$pagination,
          prevArrow: this.$pagination.find('.js-paginationArrow-prev'),
          nextArrow: this.$pagination.find('.js-paginationArrow-next'),
          asNavFor: '.js-childSlider',
          accessibility: false,
          slidesToShow: 1
        });

        // 子スライダー
        this.$childSlider.slick({
          infinite: false,
          variableWidth: true,
          arrows: false,
          accessibility: false
        }).on('click.itemSlider', '.slick-slide', function (e) {
          e.preventDefault();
          var index = parseInt($(e.currentTarget).attr('data-slick-index'), 10);
          _this2.$thumbnailSlider.slick('slickGoTo', index);
        });
      }

      // スライダーを破棄
    }, {
      key: "destroySlick",
      value: function destroySlick() {
        if (this.$childSlider.hasClass('slick-initialized')) {
          this.$childSlider.off('.itemSlider');
          this.$childSlider.slick('unslick');
        }
        if (this.$thumbnailSlider.hasClass('slick-initialized')) {
          this.$thumbnailSlider.off('.itemSlider');
          this.$thumbnailSlider.slick('unslick');
        }
      }
    }]);
  }();
  function initItemSlider() {
    new ProductItemSlider();
  }

  /*
  * PhotoSwipe 画像ギャラリー
  *
  */
  var ProductPhotoSwipeGallery = /*#__PURE__*/function () {
    function ProductPhotoSwipeGallery() {
      _classCallCheck(this, ProductPhotoSwipeGallery);
      // PhotoSwipeが読み込まれているか確認
      if (typeof PhotoSwipeLightbox === 'undefined' || typeof PhotoSwipe === 'undefined') {
        console.error('PhotoSwipe libraries are not loaded');
        return;
      }
      this.galleries = document.querySelectorAll('.js-photoswipe-gallery');
      if (!this.galleries.length) return;
      this.init();
    }

    // 初期化
    return _createClass(ProductPhotoSwipeGallery, [{
      key: "init",
      value: function init() {
        var _this3 = this;
        this.galleries.forEach(function (gallery) {
          _this3.setupGallery(gallery);
        });
      }

      // 特定の画像の読み込み（画像サイズを取得するため）
    }, {
      key: "loadImage",
      value: function loadImage(src) {
        return new Promise(function (resolve, reject) {
          var img = new Image();
          img.onload = function () {
            return resolve(img);
          };
          img.onerror = function (e) {
            return reject(e);
          };
          img.src = src;
        });
      }

      // 個別ギャラリーのセットアップ
    }, {
      key: "setupGallery",
      value: function setupGallery(gallery) {
        var _this4 = this;
        // aタグにdata-pswp-widthとdata-pswp-height属性を付ける
        var links = gallery.querySelectorAll('a');

        // すべての画像サイズを取得するPromiseを作成
        var imagePromises = Array.from(links).map(function (el) {
          return _this4.loadImage(el.href).then(function (img) {
            el.setAttribute('data-pswp-width', img.naturalWidth);
            el.setAttribute('data-pswp-height', img.naturalHeight);
          });
        });

        // すべての画像サイズ取得が完了してからPhotoSwipeを初期化
        Promise.all(imagePromises).then(function () {
          // ローディング状態を解除
          links.forEach(function (link) {
            link.classList.remove('is-loading');
          });
          var lightbox = new PhotoSwipeLightbox({
            gallery: gallery,
            children: 'a',
            pswpModule: PhotoSwipe,
            // オプション設定
            loop: true,
            // ズームアニメーション有効化
            showHideAnimationDuration: 333,
            // 背景の透明度
            bgOpacity: 0.9
          });
          lightbox.init();
        });
      }
    }]);
  }();
  function initPhotoSwipe() {
    new ProductPhotoSwipeGallery();
  }
  return {
    init: init
  };
}();
TYCOON.common.init(TYCOON.pageScript.init);